import type { IRemover } from '@/engine/UIPresentation/Interfaces';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { IValue } from '@/engine/DataFlow/Graph';
import type { IBaseViewModel } from '@/engine/app/interfaces';
import type { ValueConstructor } from '@/engine/DataFlow/DataFlow';
import type { IIndicationAdder } from '../interfaces';
import type { CancellationController } from '@/engine/Controllers/Cancellation.controller';
import { BaseRemoveCommand } from './BaseRemove.command';

export class CancelableRemoveCommand extends BaseRemoveCommand {
  private readonly _cancellationController: CancellationController;

  public constructor(
    planningAlgorithm: PlanningAlgorithm,
    remover: IRemover,
    adder: IIndicationAdder<IValue>,
    viewModel: IBaseViewModel,
    constructor: ValueConstructor,
    cancellationController: CancellationController
  ) {
    super(planningAlgorithm, remover, adder, viewModel, constructor);
    this._cancellationController = cancellationController;
  }

  public async execute(): Promise<boolean> {
    if (this._cancellationController.isCancelable(this._viewModel.descriptor)) {
      await this._cancellationController.cancelAction(this._viewModel.descriptor);
      return Promise.resolve(false);
    }
    return super.execute();
  }
}
